var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"messages-overlay",style:(_vm.styles)},_vm._l((_vm.snackbarMessages),function(item,i){return _c('Message',{key:item.id,attrs:{"message":item,"index":i}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }